import { Text } from '@/_components';
import { CardContainer } from '@/_containers';
import type { OnPartialUpdate } from '@/_schemas/types';

import { SubsidiesStatusButtonInput } from './subsidies-status';

import { useAgreementFormContext } from '../../form-context';
import { DownloadAgreementPDF } from '../../pdf-templates/download-button';
import type { AgreementUpdateSchema } from '../../schemas';
import { CommissionStatusButtonInput } from '../commission-status';

export function Header({
  isAddendum,
  isCommission,
  isSubsidy,
  onPartialUpdate,
  isPending,
}: {
  isAddendum?: boolean;
  isCommission: boolean;
  isSubsidy?: boolean;
  onPartialUpdate: OnPartialUpdate<AgreementUpdateSchema>;
  isPending: boolean;
}) {
  const form = useAgreementFormContext();
  const [id, agreement_id, client, pipeline, primary_domains] = form.watch([
    'id',
    'agreement_id',
    'client',
    'pipeline',
    'primary_domains',
  ]);

  return (
    <CardContainer>
      <section className="flex items-center justify-between">
        <div className="text-c-card-muted text-xs font-semibold">
          {isAddendum ? 'Addendum' : 'Agreement'} ID: {agreement_id || '—'}
          {!isAddendum && (
            <div className="text-c-card-muted text-xs font-semibold">Pipeline: {pipeline?.name ?? ''}</div>
          )}
        </div>

        {isCommission ? (
          <CommissionStatusButtonInput isPending={isPending} onPartialUpdate={onPartialUpdate} />
        ) : isSubsidy ? (
          <SubsidiesStatusButtonInput isPending={isPending} onPartialUpdate={onPartialUpdate} />
        ) : (
          <DownloadAgreementPDF id={`${id}`} />
        )}
      </section>

      <div className="mt-9 mb-8 text-center">
        <Text as="h5" className="text-accent mt-2 dark:text-white">
          {client?.name ?? '—'}
        </Text>
        <Text as="small" className="text-c-card-muted mt-1 font-normal">
          {primary_domains?.name ?? '—'}
        </Text>
      </div>
    </CardContainer>
  );
}
